import React from 'react';
import DailyDeviationIndicator from '@wix/da-ds/pkg/Indicators/DailyDeviationIndicator';
import deviationFlagStyles from './DeviationFlags.scss';
export const DeviationFlagBase = ({ innerRef , title  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        ref: innerRef,
        className: deviationFlagStyles['base']
    }, /*#__PURE__*/ React.createElement(DailyDeviationIndicator, {
        size: "large",
        className: deviationFlagStyles['flag']
    }), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['collapsed-title']
    }, title));
};
DeviationFlagBase.displayName = 'DeviationFlagBase';
export default DeviationFlagBase;
